module.exports = __webpack_public_path__ + "static/img/son5.97f6a65a.png";